import styled from 'styled-components';
import { Typography } from '../../../assets/styles/StyleTypes';

type ButtonPropsType = {
  margin?: string;
};
export const Button = styled.button<ButtonPropsType>`
  margin: ${(props) => (props.margin ? props.margin : 0)};
  color: ${(props) => props.theme.colors.solidButton};
  height: 40px;
  background: transparent;
  border: none;
  display: flex;
  align-items: center;
  gap: 7px;
  cursor: pointer;
`;

export const Label = styled.span`
  ${Typography.LABEL_XXS};
`;
